import React, { useState } from "react";
import { Tab, Tabs, Card } from "@material-ui/core";
import { shallowEqual, useSelector } from "react-redux";

import MainPromt from "./components/MainPromt";
import { IAppState } from "../../../store/rootDuck";
import { Settings } from "./components/Settings";
import { useIntl } from "react-intl";
import { useStyles } from "./hooks/useStyles";

export enum TabsPromt {
  MAIN_PROMT = "MAIN_PROMT",
  PROMT = "PROMT",
  DIALOG_OPENING = "DIALOG_OPENING",
  AVATAR = "AVATAR",
  SETTINGS = "SETTINGS",
}

const SettingGPTPage = () => {
  const classes = useStyles();
  const intl = useIntl();
  const profileMe = useSelector(({ auth }: IAppState) => auth.user, shallowEqual);

  const [tabValue, setTabValue] = useState(TabsPromt.MAIN_PROMT);

  if (!profileMe?.is_admin) return null;

  return (
    <Card className={classes.container}>
      <Tabs value={tabValue} indicatorColor="primary" textColor="primary">
        <Tab
          label={intl.formatMessage({ id: "MAIN.PROMT" })}
          value={TabsPromt.MAIN_PROMT}
          onClick={() => setTabValue(TabsPromt.MAIN_PROMT)}
        />
        <Tab
          label={intl.formatMessage({ id: "MENU.SETTINGS" })}
          value={TabsPromt.SETTINGS}
          onClick={() => setTabValue(TabsPromt.SETTINGS)}
        />
      </Tabs>
      {tabValue === TabsPromt.MAIN_PROMT && <MainPromt />}
      {tabValue === TabsPromt.SETTINGS && <Settings />}
    </Card>
  );
};

export default React.memo(SettingGPTPage);
